`<template>
  <aha-context-menu ref="context-menu-present">
    <p class="context-menu-header">
      {{ $i18nPresenter.t('Present') }}
    </p>
    <div
      class="flex items-center pb-0 pr-2 rounded-t-lg sm:py-2 sm:pl-4"
      @click="$emit('handlePresentMenuClick', 'present-now', true)"
      v-if="!isNewPresentation"
    >
      <div class="flex flex-col items-start justify-start">
        <span class="mb-1 font-bold text-base-90">{{ $i18nPresenter.t('Present now') }}</span>
        <span class="text-xs text-base-80">{{ $i18nPresenter.t('Present from the current slide') }}</span>
      </div>
    </div>

    <div
      class="flex items-center py-4"
      @click="$emit('handlePresentMenuClick', 'present-from-beginning', true)"
      v-if="!isNewPresentation"
    >
      <div class="flex flex-col items-start justify-start">
        <span class="mb-1 font-bold text-base-90">{{ $i18nPresenter.t('Present from beginning') }}</span>
        <span class="text-xs text-base-80">{{ $i18nPresenter.t('Present from the first slide') }}</span>
      </div>
    </div>
    <div
      class="flex items-center"
      @click="$emit('handleOpenBackstageWindow')"
      v-if="!isNewPresentation"
    >
      <div class="relative flex flex-col items-start justify-start">
        <span class="mb-1 font-bold text-base-90">
          {{ $i18nPresenter.t('Backstage') }}
          <aha-badge
            label="COMING SOON"
            size="2xs"
            class="backstage__badge --mobile"
          />
        </span>
        <span class="text-xs text-base-80">
          {{ $i18nPresenter.t('View notes and control your presentation') }}
        </span>
      </div>
    </div>
  </aha-context-menu>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      isNewPresentation: (state) => state.isNewPresentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    EventBus.$on('show-mobile-present-btn', () => {
      this.$refs['context-menu-present'].show()
    })
  },
  destroyed() {
    EventBus.$off('show-mobile-present-btn')
  },
}
</script>

<style lang="scss" scoped>
.backstage__badge {
  @apply bg-yellow-100 ml-1;
  &.--mobile {
    @apply bg-secondary-40;
    left: 4.75rem;
    top: 0.2rem;
  }
}
</style>
